var _rect, _rect2, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNoteBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1470,
    height: 2530,
    transform: "translate(-1120 -680)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-796.5 -618C-796.5 -622.142 -793.142 -625.5 -789 -625.5H330C334.142 -625.5 337.5 -622.142 337.5 -618V1842C337.5 1846.14 334.142 1849.5 330 1849.5H-789C-793.142 1849.5 -796.5 1846.14 -796.5 1842V-618Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-796.5 -618C-796.5 -622.142 -793.142 -625.5 -789 -625.5H330C334.142 -625.5 337.5 -622.142 337.5 -618V1842C337.5 1846.14 334.142 1849.5 330 1849.5H-789C-793.142 1849.5 -796.5 1846.14 -796.5 1842V-618Z",
    stroke: "#ECECF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 33,
    transform: "translate(-38 -9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    y: -8.5,
    width: 329,
    height: 32,
    rx: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    y: -8.5,
    width: 329,
    height: 32,
    rx: 5.5,
    stroke: "blue",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.06 0.761787C12.0756 -0.253929 13.7225 -0.253929 14.7382 0.761787C15.7539 1.7775 15.7539 3.42431 14.7382 4.44002L9.79089 9.38734C9.15344 10.0248 8.3265 10.4383 7.43406 10.5657L5.61747 10.8252C5.35783 10.8623 5.09587 10.7751 4.91041 10.5896C4.72496 10.4041 4.63764 10.1421 4.67473 9.88255L4.93424 8.06594C5.06173 7.1735 5.47523 6.34648 6.11266 5.70908L11.06 0.761787ZM13.5598 1.94021C13.1949 1.57532 12.6033 1.57532 12.2384 1.94021L7.29107 6.88752C6.9086 7.26999 6.66054 7.76612 6.58404 8.30158L6.48164 9.01836L7.19833 8.91595C7.73379 8.83946 8.23 8.59139 8.61248 8.20892L13.5598 3.2616C13.9247 2.89671 13.9247 2.30511 13.5598 1.94021ZM7.16617 0.833798C7.1665 1.294 6.79378 1.66735 6.33356 1.66772C5.50152 1.66836 4.91441 1.67455 4.45513 1.71819C4.00545 1.76091 3.73716 1.83529 3.53146 1.9401C3.06109 2.17976 2.67867 2.56219 2.43901 3.03255C2.32719 3.252 2.25039 3.54172 2.20919 4.04598C2.16719 4.55999 2.16654 5.2202 2.16654 6.16733V8.83379C2.16654 9.78089 2.16719 10.4411 2.20919 10.9551C2.25039 11.4593 2.32719 11.7491 2.43901 11.9685C2.67867 12.4389 3.06109 12.8213 3.53146 13.061C3.75091 13.1728 4.04063 13.2495 4.5449 13.2908C5.05889 13.3328 5.7191 13.3335 6.6662 13.3335H9.33267C10.2798 13.3335 10.94 13.3328 11.454 13.2908C11.9582 13.2495 12.248 13.1728 12.4674 13.061C12.9378 12.8213 13.3202 12.4389 13.5599 11.9685C13.6647 11.7628 13.7391 11.4945 13.7818 11.0449C13.8254 10.5856 13.8316 9.99846 13.8323 9.16644C13.8326 8.70622 14.206 8.33341 14.6662 8.33383C15.1264 8.33416 15.4991 8.70755 15.4988 9.16769C15.4981 9.98279 15.4932 10.651 15.4409 11.2025C15.3876 11.7636 15.281 12.2615 15.0447 12.7251C14.6454 13.509 14.008 14.1464 13.224 14.5459C12.7305 14.7973 12.197 14.9022 11.5897 14.9518C10.9999 15 10.2714 15 9.36834 15H6.63054C5.72743 15 4.99904 15 4.40919 14.9518C3.80186 14.9022 3.26841 14.7973 2.77487 14.5459C1.99092 14.1464 1.35354 13.509 0.954108 12.7251C0.702635 12.2315 0.597801 11.6981 0.54818 11.0908C0.499984 10.5009 0.499992 9.77256 0.5 8.86946V6.13166C0.499992 5.22854 0.499984 4.50013 0.54818 3.91028C0.597801 3.30295 0.702635 2.7695 0.954108 2.27596C1.35354 1.49201 1.99092 0.854638 2.77487 0.455193C3.2384 0.219011 3.73642 0.112427 4.29751 0.0591229C4.849 0.00672676 5.51715 0.00181044 6.33225 0.00117715C6.79245 0.000818847 7.16583 0.373591 7.16617 0.833798Z",
    fill: "currentFill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374,
    height: 2069,
    fill: "white",
    transform: "translate(-60 -602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteBlack);
export default __webpack_public_path__ + "static/media/addNoteBlack.8522a1949f18c4abe443e7d10799064c.svg";
export { ForwardRef as ReactComponent };